import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Box, Grid, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import DropDownButton from "../DropDown/DropDownButton";
import { useLocation, useNavigate } from "react-router-dom";
import Profile from "../Modal/Profile";
import { getProjectsDb } from "../../Layouts/Projects/Services";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import RefreshIcon from "@mui/icons-material/Refresh";
import Badge from "@mui/material/Badge";
import SwapHorizontalCircleIcon from "@mui/icons-material/SwapHorizontalCircle";
import { getUserRequestsDb } from "../../Layouts/Users/Services";

import SalespersonDropdown from "./SalespersonDropdown";
import { commonSliceActions } from "../../Store/Slices/CommonSlice";

import { map } from "lodash";
const Header = (props) => {
  const location = useLocation();
  const navigation = useNavigate();
  const dispatch = useDispatch();

  const [logos, setLogos] = useState([]);
  const [pendingCount, setPendingCount] = useState(0);

  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const roleTitle = userInfo.rolesInfo.title.toLowerCase();
  const canViewUserRequests = ["salesadmin", "hradmin"].includes(roleTitle);
  const { user_uid } = useSelector((state) => state.common.filterData || {});

  const myProjects = useSelector((state) => state.loggedInUserInfo.myProjects);

  useEffect(() => {
    if (roleTitle === "salesperson") {
      dispatch(commonSliceActions.resetState());
      dispatch(
        commonSliceActions.setFilterData({ user_uid: userInfo.uid || null }),
      );
    } else if (roleTitle === "salesadmin") {
      dispatch(commonSliceActions.resetState());
    }
  }, [userInfo.uid, roleTitle, dispatch]);

  useEffect(() => {
    if (!canViewUserRequests) return;
    fetchPendingCount(); // initial
    const interval = setInterval(fetchPendingCount, 60000); // 60 sec
    return () => clearInterval(interval); // cleanup
  }, [canViewUserRequests]);

  useEffect(() => {
    if (myProjects && myProjects.length > 0) {
      projectFetch(myProjects);
    }
  }, [myProjects]);

  const projectFetch = async (projects) => {
    let params = {
      query: {
        $select: ["project_logo"],
        uid: projects,
        is_deleted: false,
        $limit: -1,
        $sort: {
          created_at: -1,
        },
      },
    };
    try {
      let resProjectData = await getProjectsDb(params);
      let logoArr = map(resProjectData.data, "project_logo");
      setLogos(logoArr);
    } catch (error) {
      console.log("err", error);
    }
  };

  const fetchPendingCount = async () => {
    let query = {};
    
    if (roleTitle === "salesadmin") {
      query.userRole = "salesperson";
    } else if (roleTitle === "hradmin") {
      query.userRole = "trainer";
    }
    
    try {
      const res = await getUserRequestsDb({ query });
      const newData = res.data;
      const pendingTotal = newData.length ? newData[0].total_count : 0;
      console.log("Pending count:", pendingTotal);
      setPendingCount(pendingTotal);
    } catch (err) {
      console.error("Failed to fetch pending count:", err);
    }
  };

  return (
    <Grid container>
      {/* <Grid item xs={12}>
                <Grid container direction="row" justifyContent="flex-end"  alignItems="center" className='pr-1'>
                    <img src='/logo.png' width='45rem'></img>
                </Grid>
            </Grid> */}
      <Grid
        size={12}
        sx={{
          borderBottom: 1,
          borderBottomColor: "#EFEFEF",
        }}
      >
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className="pl-3"
        >
          <Grid style={{ flex: 1 }}>
            {/* <IconButton onClick={props.onMenuClick}>
              <MenuIcon />
            </IconButton> */}
            {location.pathname.split("/").includes("Profile") && (
              <DropDownButton hide={true} />
            )}
            {userInfo &&
              userInfo.rolesInfo.title.toLowerCase() == "client" &&
              logos &&
              logos.map((val) => {
                return (
                  <img
                    src={
                      process.env.REACT_APP_SERVER_API +
                      "/media/documents/" +
                      val
                    }
                    height="50vh"
                  ></img>
                );
              })}
            {(location.pathname.includes("Users") ||
              location.pathname.includes("Departments") ||
              location.pathname.includes("Designations") ||
              location.pathname.includes("Dashboard") ||
              location.pathname.includes("Administrator") ||
              location.pathname.includes("Projects") ||
              location.pathname.includes("Institutes") ||
              location.pathname.includes("Trainings") ||
              location.pathname.includes("Calendar") ||
              location.pathname.includes("FeedbackResponse") ||
              location.pathname.includes("Reports") ||
              location.pathname.includes("Inventory") ||
              location.pathname.includes("Tools") ||
              location.pathname.includes("Attendance") ||
              location.pathname.includes("Leaves") ||
              location.pathname.includes("HRTools") ||
              location.pathname.includes("Documents") ||
              location.pathname.includes("Payroll")) && (
              <DropDownButton text={""} hide={true} />
            )}
          </Grid>
          <Grid className="pr-1">
            <Grid container alignItems="center" spacing={2} wrap="nowrap">
              {roleTitle === "salesadmin" &&
                location.pathname.includes("SalesDashboard") && (
                  <>
                    <Grid item>
                      <SalespersonDropdown
                        ukey="salesperson-dropdown-header"
                        value={user_uid}
                        onChange={(selectedUsers) => {
                          dispatch(commonSliceActions.resetState());
                          dispatch(
                            commonSliceActions.setFilterData({
                              user_uid: selectedUsers?.value || null,
                            }),
                          );
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <IconButton
                        onClick={() => {
                          dispatch(commonSliceActions.setDashboardReset(true));
                        }}
                        sx={{
                          bgcolor: "primary.main",
                          color: "#fff",
                          height: "2.5rem",
                          width: "2.5rem",
                          "&:hover": {
                            bgcolor: "primary.dark",
                          },
                        }}
                      >
                        <RefreshIcon sx={{ fontSize: "1.8rem" }} />
                      </IconButton>
                    </Grid>
                  </>
                )}

              {canViewUserRequests && (
                <Grid item>
                  <IconButton
                    onClick={() => navigation("/Users/Requests")}
                    sx={{
                      bgcolor: "primary.main",
                      color: "#fff",
                      height: "2.5rem",
                      width: "2.5rem",
                      "&:hover": {
                        bgcolor: "primary.dark",
                      },
                    }}
                  >
                    <Badge badgeContent={pendingCount} color="error">
                      <PendingActionsIcon />
                    </Badge>
                  </IconButton>
                </Grid>
              )}

              {props.tileAllPermissions?.length > 1 && (
                <Grid item>
                  <IconButton
                    sx={{
                      bgcolor: "primary.main",
                      color: "#fff",
                      height: "2.5rem",
                      width: "2.5rem",
                      "&:hover": {
                        bgcolor: "primary.dark",
                      },
                    }}
                    onClick={props.tileOpen}
                  >
                    <SwapHorizontalCircleIcon />
                  </IconButton>
                </Grid>
              )}

              {!location.pathname.includes("Profile") && (
                <Grid item>
                  <Profile />
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default Header;
